module.exports = __webpack_public_path__ + "img/qr_scan_icon.bc8713a9.png";